<template>
  <v-layout xs12 class="drop-down-wrapper">
    <v-flex>
      <v-card class="drop-down pt-4 pb-4 pl-6 pr-6" raised>
        <v-card-title class="d-flex rtl pa-0 titleCats">
          <v-col cols="6" class="pa-0 ma-0">
            <p class="pa-0 ma-0">בחירת קטגוריה</p>
          </v-col>
          <v-col cols="6" class="pa-0 ma-0 text-left">
            <span
              class="text-left pa-0 ma-0"
              @click="$emit('update:pressed', false)"
            >
              <v-icon
                class="icon-forma-1-2 pointer display-18"
                id="cat-close-x"
              />
            </span>
          </v-col>
        </v-card-title>

        <!-- <DropDivider :width="'100%'" /> -->

        <v-card-text class="rtl text-right px-0 pt-1">
          <v-row class="px-0">
            <v-col
              v-for="(category, index) in categories"
              :key="index"
              class="py-2 pb-1"
              cols="6"
              xl="4"
              lg="4"
              md="4"
              xs="6"
              sm="6"
            >
              <nuxt-link
                :to="`jobs/cat${category.id}`"
                target="_self"
                class="display-14 black--text no-underline d-flex"
                data-cy="cy-cat-item"
                :title="category.name"
                :prefetch="false"
              >
                <span class="inline-flex display-14 cat-name">
                  {{ category.name }}
                </span>
              </nuxt-link>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { CATEGORIES } from '@/lib/api.js';
export default {
  data() {
    return {
      categories: [],
    };
  },
  props: {
    pressed: Boolean,
    text: {
      type: String,
      default: '',
    },
  },

  async fetch() {
    try {
      const { data: { data: data } } = await this.$axios.get(CATEGORIES);

      if (!data) {
        throw data.Errors;
      }

      this.categories = data;

    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style lang="scss" scoped>
.titleCats {
  border-bottom: 4px solid #f6f7f9;
}
.drop-down-wrapper {
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 225px;
}

.drop-down.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 5px;
  border: solid 1px #d7d7d7;
  z-index: 110;
}
.icon-forma-1-2 {
  color: $primary;
}

.total-jobs {
  color: #a2a3a4;
}
a:hover,
a:visited,
a:link,
a:active {
  text-decoration: none;
}
.cat-name:hover {
  text-decoration: underline;
}
@media screen and (max-width: 768px) {
  .drop-down-wrapper {
    top: -60px;
    width: 98%;
    z-index: 700;
    max-height: 78vh;
  }

  .drop-down-hdr {
    direction: rtl;
  }

  .drop-down {
    border-radius: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    direction: ltr;
  }
}

@media screen and (max-width: 450px) {
  .drop-down-wrapper {
    top: -40px;
    max-height: 36vh;
  }

  .icon-forma-1-2 {
    font-size: 14px;
  }
}
</style>
